// extracted by mini-css-extract-plugin
export var blue = "_10-f";
export var brand = "_10-b";
export var darkGrey = "_10-e";
export var disabled = "_10-4";
export var disabledSubtle = "_10-5";
export var error = "_10-6";
export var green = "_10-g";
export var grey = "_10-d";
export var icon = "_10-0";
export var inherit = "_10-a";
export var lightGrey = "_10-c";
export var orange = "_10-i";
export var pink = "_10-k";
export var primary = "_10-1";
export var purple = "_10-l";
export var red = "_10-j";
export var secondary = "_10-2";
export var success = "_10-9";
export var tertiary = "_10-3";
export var warning = "_10-7";
export var warningSecondary = "_10-8";
export var white = "_10-m";
export var yellow = "_10-h";